/**
 * Darstellung (Design 10a/11a): Hell / Dunkel / System. „system" folgt prefers-color-scheme live.
 * Geteilt zwischen AppShell (Konto-Menü) und der „Mein Konto"-Seite, damit beide denselben
 * Zustand lesen/schreiben. Backwards-kompatibel zu den alten Werten „light"/„dark" in localStorage;
 * unbekannt -> „system".
 */
import { useEffect, useState } from "react";

export type Theme = "light" | "dark" | "system";

const KEY = "maestro-theme";

export function readTheme(): Theme {
  const v = localStorage.getItem(KEY);
  return v === "light" || v === "dark" || v === "system" ? v : "system";
}

export function useTheme(): [Theme, (t: Theme) => void, boolean] {
  const [theme, setTheme] = useState<Theme>(readTheme);
  const [resolvedDark, setResolvedDark] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => {
      const dark = theme === "dark" || (theme === "system" && mq.matches);
      document.documentElement.classList.toggle("dark", dark);
      setResolvedDark(dark);
    };
    apply();
    localStorage.setItem(KEY, theme);
    if (theme === "system") {
      mq.addEventListener("change", apply);
      return () => mq.removeEventListener("change", apply);
    }
  }, [theme]);
  return [theme, setTheme, resolvedDark];
}

export const THEME_OPTS: { value: Theme; icon: string; label: string }[] = [
  { value: "light", icon: "light_mode", label: "Hell" },
  { value: "dark", icon: "dark_mode", label: "Dunkel" },
  { value: "system", icon: "computer", label: "System" },
];
